import { queryParams } from '@dxp-module/common'
import { UrlParamTypes } from '../enum/UrlParamTypes'
import { UrlParams } from '../model/UrlParams'

const collectedFilters = () => {
  const token = queryParams.getParam(UrlParamTypes.TOKEN, window.location)

  const filters: UrlParams = {
    token: token || '',
  }

  return { filters }
}

export default collectedFilters
